module.exports = __webpack_public_path__ + "static/img/title2.55f41a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/screen/title2.png
// module id = VoSu
// module chunks = 1